import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllVideos } from "@store/action/multimedia/VideoAction";
const URL = process.env.REACT_APP_MICRO_MULTIMEDIA_URL;

const VideoLast = ({ t }) => {
  const dispatch = useDispatch();
  const Videos = useSelector((state) => state.VideoReducer);
  useEffect(() => {
    dispatch(
      getAllVideos({
        page: 1,
        per_page: 5,
      })
    );
  }, [dispatch, Videos?.data?.length]);
  return (
    <div className="treanding_songs_wrapper release_wrapper ms_cover">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="ms_heading_wrapper">
              <h1>{t("Recent Videos")}</h1>
            </div>
            <div className="relaese_viewall_wrapper">
              <Link to={`/Gallery/Videos/topics`}>
                {t("view all")}
                <i className="flaticon-right-arrow" />
              </Link>
            </div>
          </div>
          {Videos?.data
            ? Videos?.data?.map((el, i) => {
                return (
                  <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12" key={i}>
                    <div className="treanding_slider_main_box top_artist_wrapper_new ms_cover">
                      <video
                        height={"250px"}
                        src={el.file_path}
                      />
                      <div className="ms_treanding_box_overlay">
                        <div className="ms_tranding_box_overlay" />
                        <div className="tranding_play_icon various_concert_icon">
                          <Link to={`/Gallery/Videos/topics/${el.id}`}>
                            <i className="flaticon-play-button" />
                          </Link>
                        </div>
                      </div>
                      <div className="various_song_playlist">
                        <p>
                          <Link to={`/Gallery/Videos/topics/${el.id}`}>
                            <span style={{ display: "block" }}>
                              {el.file_name}
                            </span>
                            {el.video_info?.length_text}
                          </Link>
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })
            : t("No recent videos")}
        </div>
      </div>
    </div>
  );
};

export default VideoLast;
